import colors from "../../../style/colors";

const styles = () => ({
  tab: {
    position: "fixed",
    right: 0,
    top: "75%",
    transform: "translateY(-50%)",
    zIndex: 1200,
    padding: 0,
    border: "none",
    cursor: "pointer",
    backgroundColor: colors.primary,
    color: colors.primaryContrastText,
    borderTopLeftRadius: 6,
    borderBottomLeftRadius: 6,
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.2)",
    transition: "background-color 0.2s ease",
    "&:hover": {
      backgroundColor: colors.primaryDark,
    },
  },
  inner: {
    display: "flex",
    alignItems: "center",
    gap: 6,
    padding: "14px 8px",
    writingMode: "vertical-rl",
    transform: "rotate(180deg)",
  },
  icon: {
    fontSize: 18,
  },
  label: {
    fontSize: 13,
    fontWeight: 600,
    letterSpacing: 0.3,
  },
  panel: {
    width: "100%",
    maxHeight: "85vh",
    display: "flex",
    flexDirection: "column",
    boxSizing: "border-box",
  },
  panelBody: {
    flex: 1,
    overflow: "auto",
  },
  // Matches @atmt/feedback-component-web's own internal loading screen
  // exactly (colors/sizing/animation lifted from its compiled styles), so
  // there's no visual hand-off between our loading state and the widget's.
  loadingRoot: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "60px 40px",
    minHeight: 220,
    fontFamily:
      "'Everyday Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif",
  },
  "@keyframes atmtLoadingSpin": {
    "0%": { transform: "rotate(0deg)" },
    "100%": { transform: "rotate(360deg)" },
  },
  spinner: {
    width: 52,
    height: 52,
    borderRadius: "50%",
    border: "4px solid #e8eaed",
    borderTopColor: "#0053E2",
    animation: "$atmtLoadingSpin 0.9s linear infinite",
  },
  errorRoot: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "60px 40px",
    minHeight: 220,
    gap: 16,
  },
  errorText: {
    color: colors.darker,
    textAlign: "center",
    margin: 0,
  },
});

export default styles;
